import { Card, CardContent } from "@/components/ui/card";
import { Archive, Clock, PlayCircle } from "lucide-react";
import { fmtSize } from "./backupFormat";

export function NextRunCard({ nextRun }) {
  if (!nextRun) return null;
  if (!nextRun.configured) {
    return (
      <Card className="border-slate-200 bg-slate-50" data-testid="card-next-backup-vault-nao-configurado">
        <CardContent className="pt-4 pb-4 flex items-center gap-3">
          <div className="p-2 rounded-lg bg-slate-200"><Clock className="w-5 h-5 text-slate-600" /></div>
          <div>
            <div className="text-xs uppercase tracking-wide text-slate-600 font-semibold">Próximo backup por empresa</div>
            <div className="text-sm text-slate-700">{nextRun.message || "Selecione uma empresa para ver o próximo backup automático."}</div>
            <div className="text-xs text-muted-foreground">Empresas sem horário próprio usam o horário global configurado abaixo.</div>
          </div>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card className="border-sky-200 bg-gradient-to-br from-sky-50 to-white" data-testid="card-next-backup-vault">
      <CardContent className="pt-4 pb-4 flex items-center gap-3">
        <div className="p-2 rounded-lg bg-sky-100"><Clock className="w-5 h-5 text-sky-700" /></div>
        <div>
          <div className="text-xs uppercase tracking-wide text-sky-600 font-semibold">
            Próximo backup automático{nextRun.mode === "global" && " · horário global"}
          </div>
          <div className="text-lg font-bold text-slate-800" data-testid="vault-next-backup-time">{nextRun.next_run_local}</div>
          <div className="text-xs text-muted-foreground">em <b>{nextRun.human}</b> · horários: <b>{nextRun.configured_slots}</b> BRT · cron: <code>{nextRun.cron_expression}</code></div>
          {nextRun.mode === "global" && (
            <div className="text-xs text-amber-700 mt-1" data-testid="vault-next-backup-global-hint">{nextRun.message}</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

export function BackupProgressCard({ currentlyProcessing }) {
  return (
    <Card className="border-indigo-300 bg-indigo-50/50" data-testid="backup-progress-card">
      <CardContent className="pt-5 pb-5">
        <div className="flex items-center gap-3 mb-3">
          <PlayCircle className="w-5 h-5 text-indigo-600 animate-pulse" />
          <div className="flex-1">
            <div className="font-semibold text-sm text-indigo-900">
              {currentlyProcessing
                ? <>Fazendo backup de <b className="text-indigo-700">{currentlyProcessing.empresa_nome}</b>…</>
                : "Backup em execução…"}
            </div>
            <div className="text-xs text-indigo-700">Zipando coleções do MongoDB · não feche a página</div>
          </div>
        </div>
        <div className="w-full h-2 bg-indigo-100 rounded-full overflow-hidden">
          <div className="h-full w-1/3 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-full"
            style={{ animation: "backup-slide 1.4s ease-in-out infinite" }} />
        </div>
        <style>{`@keyframes backup-slide { 0%{transform:translateX(-100%);width:30%} 50%{width:60%} 100%{transform:translateX(400%);width:30%} }`}</style>
      </CardContent>
    </Card>
  );
}

export function BackupStats({ files }) {
  if (!files.length) return null;
  const totalSize = files.reduce((s, f) => s + (f.size_bytes || 0), 0);
  const successCount = files.filter((f) => f.status === "success").length;
  const errorCount = files.filter((f) => f.status === "error").length;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Card><CardContent className="pt-5"><div className="text-xs text-muted-foreground">Arquivos</div><div className="text-2xl font-bold" data-testid="stat-total-files">{files.length}</div></CardContent></Card>
      <Card><CardContent className="pt-5"><div className="text-xs text-muted-foreground">Sucessos</div><div className="text-2xl font-bold text-emerald-700" data-testid="stat-success">{successCount}</div></CardContent></Card>
      <Card><CardContent className="pt-5"><div className="text-xs text-muted-foreground">Erros</div><div className="text-2xl font-bold text-rose-700" data-testid="stat-errors">{errorCount}</div></CardContent></Card>
      <Card><CardContent className="pt-5"><div className="text-xs text-muted-foreground">Tamanho total</div><div className="text-2xl font-bold" data-testid="stat-size">{fmtSize(totalSize)}</div></CardContent></Card>
    </div>
  );
}

export function BackupEmptyState() {
  return (
    <Card><CardContent className="py-16 text-center text-muted-foreground" data-testid="backups-empty">
      <Archive className="w-12 h-12 mx-auto mb-3 text-slate-400" />
      <p className="font-semibold text-lg">Nenhum backup ainda</p>
      <p className="text-xs mt-1">Clique em "Rodar agora" pra gerar o primeiro.</p>
    </CardContent></Card>
  );
}
